import { render, staticRenderFns } from "./ShareBackupRecipients.vue?vue&type=template&id=09a43b2a"
import script from "./ShareBackupRecipients.vue?vue&type=script&lang=js"
export * from "./ShareBackupRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports